import Search from '@mui/icons-material/Search'

interface ISearchInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
}

/**
 * Input with search icon on the right
 */
export const SearchInput = ({
  className,
  type,
  ...props
}: ISearchInputProps) => {
  return (
    <div className='flex items-center'>
      <input
        // prefer text type as search will include clear button
        type={type ?? 'text'}
        // try to preserve component style customization even with custom classes
        className={`${className ?? ''} pr-9 w-60 rounded-sm`}
        {...props}
      />
      {/* REVIEW: can be expanded with onClick callbacks */}
      <Search className='-ml-8 text-gray-700 pointer-events-none' />
    </div>
  )
}
